export default {

    state: {
        type: true
    }

    // getters: {
    // },

    // actions: {

    // },

    // mutations: {

    // }
}
